import React from 'react'
import { useContext } from 'react'
import {RoomContext} from '../context'
import Title from "./title";
// get unique rooms type
const getUnique = (items,value)=>{
    return [...new Set(items.map(item => item[value]))]
}
export default function RoomsFilter({rooms}) {
    const context = useContext(RoomContext)
    // console.log(context)
    const {handleChange, type, capacity, price, minPrice, maxPrice, minSize, maxSize, breakfast, pets } = context
    // get unique types
    let types = getUnique(rooms, 'type')
    // add 'all' type
    types = ['all',...types]
    // map to jsx
    types = types.map((item, index)=>{
        return <option value={item} key={index}>
            {item}
        </option>
    })
    let people = getUnique(rooms, 'capacity')
    people = people.map((item,index)=>{
        return <option key={index} value={item}>
             {item}
        </option>
    })
    return (
        <section className='filter-container'>
            <Title title='search rooms' />
            <form className='filter-form'>
                {/* select input */}
                <div className='form-group'>
                    <label htmlFor='type'>room type</label>
                        <select id='type' name='type' value={type} className='form-control' onChange={handleChange}>
                            {types}
                        </select>
                </div>
                {/* select ends */}

                {/* guest input */}
                <div className='form-group'>
                    <label htmlFor='capacity'>guest</label>
                        <select id='capacity' name='capacity' value={capacity} className='form-control' onChange={handleChange}>
                            {people}
                        </select>
                </div>
                {/* guest ends */}

                {/* room price input */}
                <div className='form-group'>
                    <label htmlFor='price'>Room Price ${price}</label>
                        <input type='range' id='price' name='price' min={minPrice} max={maxPrice} value={type} className='form-control' onChange={handleChange} />
                </div>
                {/* room price ends */}

                {/* room size input */}
                <div className='form-group'>
                    <label htmlFor='size'>Room Size</label>
                    <div className='size-inputs'>
                        <input type='number' name='minSize' id='size' value={minSize} onChange={handleChange} className='size-input' />
                        <input type='number' name='maxSize' id='size' value={maxSize} onChange={handleChange} className='size-input' />
                    </div>
                </div>
                {/* room size ends */}

                {/* room extras input */}
                <div className='form-group'>
                    <div className='single-extra'>
                        <input type='checkbox' name='breakfast' id='breakfast' checked={breakfast} onChange={handleChange} />
                        <label htmlFor='breakfast'>Breakfast</label>
                    </div>
                    <div className='single-extra'>
                        <input type='checkbox' name='pets' id='pets' checked={pets} onChange={handleChange} />
                        <label htmlFor='pets'>Pets</label>
                    </div>
                </div>
                {/* room extras ends */}
            </form>
        </section>
    )
}
